import styled from 'styled-components'

export const FilterSection = styled.div`
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
`

export const FilterSectionTitle = styled.div`
  font-size: 12px;
  font-weight: bold;
  color: #00a0a8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
`

export const FilterLabel = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #333;
  margin-bottom: 6px;
`

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
`

export const ResetButton = styled.span`
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`
